<ng-container *ngIf="isLoading else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>
  <div class="manage-courses">
    <div class="header ms-3">
	<div class="d-flex">
      <h2>Manage Courses</h2>
    <span class="count-badge ms-2">{{ _totalCourseCount }}</span>
	</div>
      <div class="filter-create">

        <div class="filter-dropdown">
          <button (click)="toggleFilter()" class="filter-btn">
            <i class="bi bi-filter"></i> {{ selectedCourseFilter }}
          </button>
          <div class="dropdown" *ngIf="filterOpen">
            <label *ngFor="let status of courseStatuses">
              <input type="radio" name="filter" 
                     [checked]="selectedCourseFilter === status" 
                     (change)="onFilterChange(status, StudyMaterialTypeEnum.Course)" /> 
              {{ status }}
            </label>
          </div>
        </div>

		
		 <div class="modal-backdrop" *ngIf="isCourseCreationModalOpen">
          <div class="modal-container" (click)="$event.stopPropagation()">
            <button class="close-btn" (click)="closeCourseCreationModal()"><i class="bi bi-x"></i></button>
            <h3 class="modal-title">Choose Course Creation Type</h3>
            <p class="subtitle">
              Would you like to build your course step-by-step, or let AI help you generate one instantly?
            </p>

            <div class="card-container">
              <div class="option-card">
                <div class="icon-purple">
                  <img class="icon" src="assets/images/note.svg" alt="Manual Icon" />
                </div>
                <h5>Manual Creation</h5>
                <ul>
                  <li>Step-by-step creation – ideal if you already have your syllabus.</li>
                  <li>You’ll add your course details, objectives, and units manually.</li>
                </ul>
                <button class="option-btn" (click)="goToCoursePage()">
                  Manual Creation
                  <img class="create-icon" src="assets/images/arrow.svg" alt="Manual Icon" />
                </button>
              </div>

              <div class="option-card">
                <div class="icon-purple">
                  <img class="icon" src="assets/images/robot.svg" alt="AI Icon" />
                </div>
                <h5>AI-Powered Generation</h5>
                <ul>
                  <li>Let AI generate your complete course structure with just one line!</li>
                  <li>Enter a short description and AI will create the structure for you.</li>
                </ul>
                <button class="option-btn" (click)="generateWithAI()">
                  Generate With AI
                  <img class="create-icon" src="assets/images/ai01.svg" alt="AI Icon" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <button class="create-btn" (click)="openCourseCreationModal()"> <i class="bi bi-plus"></i> Create Course</button>
      </div>
    </div>

    <div class="course-grid" *ngIf="_courseData.length > 0; else noCourse">
      <div class="course-card" *ngFor="let course of _courseData">

		 <div class="spinner-overlay" *ngIf="course.status === CourseStatusEnum.In_Progress">
            <app-hourglass-loader-course></app-hourglass-loader-course>
	          You will be notified as soon as your course is generated successfully.
                </div>
        <div class="course-status" [ngClass]="course.status | lowercase">{{ course.status }}</div>
        <div class="course-content">
          <div class="icon-title d-flex align-items-center justify-content-between mt-4">

            <img src="assets/images/note01.svg" alt="Course Icon" class="course-icon" />
            <div class="title-units d-flex align-items-center justify-content-between flex-grow-1">
              <span class="course-title ms-2">{{ course.course_title || "N/A" }}</span>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item *ngIf="course.course_id && course.course_title && course.status === CourseStatusEnum.Draft"
                        (click)="openEditTitleBox(course.course_id, course.course_title, EditableStudyMaterialTypeEnum.Course)">
                  Edit
                </button>
                <button mat-menu-item *ngIf="course.course_id"
                        (click)="openDeleteDialogBox(course.course_id, StudyMaterialTypeEnum.Course)">
                  Delete
                </button>
              </mat-menu>
              </div>
          </div>
		   <div class="units ms-5">
                <i class="bi bi-journal-text"></i> Units: {{ course.total_units_count }}
            </div> 
          <hr />
          <div class="button-container">
            <button class="view-btn" *ngIf="course.course_id" (click)="goTocoursePage(course.course_id!)">
              <i class="bi bi-box-arrow-up-right"></i> View Course
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
       <ng-template #noCourse>
      <div class="text-center mt-5">
        <p>No Courses Found</p>
      </div>
      </ng-template>
</ng-template>